import { styled } from 'styled-components';

export const ContentLayout = styled.div`
  padding: 0px 24px;
  height: 100%;
`;
